function getDefaultContactsTableColumnStoredValue() {
    return {
        width: 160,
        isShown: true,
    };
}
export default getDefaultContactsTableColumnStoredValue;
